import { createAxiosClient } from '@shopmuchmore/api'
import { toast } from 'sonner'
import { env } from '../env' // Assuming env.ts is at src root
import { useAuthStore } from '../features/auth/auth.store'

// Instantiate the shared client with app-specific config
export const apiClient = createAxiosClient({
  baseURL: env.VITE_API_BASE_URL,
  authStore: useAuthStore, // Zustand store instance
  notificationSystem: toast, // Sonner toast instance
})
